
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import SchemaProfile from '@/components/schemas/SchemaProfile.vue';

import userx from '@/store/modules/userx';
import schemax from '@/store/modules/schemax';

import { SoftwareType, SchemaDic, SchemaData } from '@/store/models.def';

@Component({
	components: {},
})
export default class AllSchemas extends Vue {
	@Prop() public value!: SchemaData | null;

	public get groupedSchemas(): SchemaDic {
		return schemax.groupedSchemas;
	}
	public get defaultSchema(): SchemaData | null {
		return this.groupedSchemas.sql[this.groupedSchemas.sql.length - 1];
	}

	public currentSchema: SchemaData | null = this.defaultSchema || null;

	@Watch('defaultSchema')
	public onDefaultSchemaChange(
		val: SchemaData | null,
		oldValue: SchemaData | null,
	) {
		if (this.currentSchema === null) {
			this.currentSchema = val;
			this.emitInput();
		}
	}
	@Watch('value')
	public onValueChange(val: SchemaData | null, oldValue: SchemaData | null) {
		if (val) {
			if (!this.currentSchema || val.id !== this.currentSchema.id) {
				this.currentSchema = val;
			}
		}
	}

	public mounted() {
		if (this.currentSchema) { this.emitInput(); }
	}

	public onSelect(selected: SchemaData) {
		this.currentSchema = selected;
		this.emitInput();
	}

	public emitInput() {
		this.$emit('input', JSON.parse(JSON.stringify(this.currentSchema)));
	}
}
